export default __webpack_public_path__ + "hire_exit_periods.png";